import {
    BannerLink,
    BannerImage
} from './bannerElements'

const Banner = ({image, hidebanner}) => {
    return (

        <BannerLink hidebanner={hidebanner} to='/'>
            <BannerImage src={image} />
        </BannerLink>
    )
}

export default Banner
